import proj4 from 'proj4';
import * as proj from 'ol/proj';
import axios from 'axios';
import * as ol from 'ol';
import * as layer from 'ol/layer';
import * as source from 'ol/source';
import * as control from 'ol/control';
import * as style from 'ol/style';
import * as tilegrid from 'ol/tilegrid';
import * as geom from 'ol/geom';
import {register} from 'ol/proj/proj4.js';
import Alpine from "alpinejs";
import styleGeometry from "../style.js";


const domainGeo = 'https://geo.mapbaza.ru';
let layers = [36049, 36048, 36328, 36329];

let layersName = [
    {id: 36049, group_id: 1, searchId: 1, favorite: true, name: 'Здания', cat_id: 36369, reserved: true},
    {id: 36328, group_id: 1, searchId: 1, favorite: true, name: 'Сооружения', cat_id: 36383, reserved: true},
    {id: 36329, group_id: 1, searchId: 1, favorite: true, name: 'Объекты незавершенного строительства', cat_id: 36384, reserved: true},
    {id: 36048, group_id: 2, searchId: 1, favorite: true, name: 'Земельные участки ЕГРН', cat_id: 36368, reserved: true},
]

window.Alpine = Alpine;
Alpine.store("Karta", Karta());
let store = Alpine.store("Karta");
Alpine.start()

Alpine.effect(() => {
    const value = Alpine.store("Karta").info;
    const container = Alpine.store("Karta").scrollContainer;

    if (!container) return;

    if (value) {
        store.scrollY = container.scrollTop;
    } else {
        queueMicrotask(() => {
            container.scrollTop = store.scrollY;
        });
    }
});


window.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

let currentZoom;
let sourceAnalyticsTb;

initMap();

async function initMap() {
    window.myMap = new ol.Map({
        target: 'map',
        maxTilesLoading: 100,
        controls: control.defaults({
            zoom: false,
            attribution: false,
            rotate: false,
            ScaleLine: true
        }),
    });

    proj4.defs('EPSG:3395', '+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs');
    register(proj4);

    const uri = getParamsUri();

    let center = [uri?.lon || 37.617698, uri?.lat || 55.755864]

    const paramsMap = {
        center: proj.fromLonLat(center),
        zoom: uri?.z || 7,
    }

    let layerCollection = [];
    let view = new ol.View(paramsMap)
    myMap.setView(view);

    let extent = myMap.getView().calculateExtent(myMap.getSize());

    [extent[0], extent[1]] = proj.transform([extent[0], extent[1]], 'EPSG:3857', 'EPSG:4326');
    [extent[2], extent[3]] =  proj.transform([extent[2], extent[3]], 'EPSG:3857', 'EPSG:4326');

    layerCollection.push(new layer.Tile({
        zIndex: 1,
        source: new source.XYZ({
            url: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&x={x}&y={y}&z={z}',
            projection: 'EPSG:3395',
            tileGrid: tilegrid.createXYZ({
                extent: [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
            })
        })
    }))

    sourceAnalyticsTb = new source.Vector();

    layerCollection.push(
        new layer.Vector({
            zIndex: 5,
            source: sourceAnalyticsTb,
            style: styleGeometry.clusterStyleTb
        })
    );


    if (window.location.pathname === '/kad') {

        layers.forEach((layerNumber) => {
            const groupId = layersName.find(l => l.id === layerNumber)?.group_id;
            let maxResolution = 100000;
            let minResolution = 0;

            if ([1, 2].includes(groupId)) {
                maxResolution = 15;
            }

            if (layerNumber === 36071) {
                minResolution = 0;
                maxResolution = 200;
            } else if (layerNumber === 36070) {
                minResolution = 200;
                maxResolution = 600;
            } else if (layerNumber === 36945) {
                minResolution = 15;
            }

            const layerId = layerNumber;

            const urls = [domainGeo + '/geoserver/postgis/wms'];
            layerNumber = 'postgis:layer_' + layerNumber


            let sourceLayer = new source.TileWMS({
                urls: urls,
                params: {
                    'SERVICE': 'WMS',
                    'VERSION': '1.3.0',
                    'REQUEST': 'GetMap',
                    'FORMAT': 'image/png',
                    'TRANSPARENT': true,
                    'LAYERS': layerNumber,
                    'STYLES': '',
                    'CRS': 'EPSG:3857',
                },
                //tileLoadFunction: createLimitedTileLoadFunction(10),
                tileGrid: tilegrid.createXYZ({
                    extent: proj.get('EPSG:3857').getExtent(),
                    tileSize: 512,
                }),
            });

            let layerTile = new layer.Tile({
                zIndex: 2,
                source: sourceLayer,
                maxResolution: maxResolution,
                minResolution: minResolution,
            })

            layerTile.set('id', layerId)

            layerCollection.push(layerTile);
        });
    }

    myMap.setLayers(layerCollection);

    myMap.on('moveend', (e) => {
        setAnalyticsLayers(currentZoom !== myMap.getView().getZoom());
        currentZoom = myMap.getView().getZoom();
        let center = myMap.getView().getCenter();
        center = proj.transform(center, 'EPSG:3857', 'EPSG:4326');

        window.history.replaceState({}, '', '?z=' + Math.round(currentZoom) + `&lon=${center[0]}&lat=${center[1]}`)
    });

    myMap.on('singleclick', (e) => eventClick(e));

}


async function eventClick(e) {
    let clickObject = false;
    myMap.forEachFeatureAtPixel(e.pixel, function (feature) {
        if (sourceAnalyticsTb.hasFeature(feature)) {
            getAnalyticsInfoItem(feature)
            clickObject = true;
        }
    });

    if (!clickObject) {
        store.lots = [];
        store.info = {}
    }
}

async function getAnalyticsInfoItem(feature) {
    if (!feature.get('ids') || (feature.get('ids')?.length > 3 && myMap.getView().getZoom() < 18)) {
        myMap.getView().setZoom(myMap.getView().getZoom() + 2);
        myMap.getView().setCenter(feature.getGeometry().getCoordinates())
    } else {
        store.info = {}
        store.lots = [];
        if (feature.get('ids')?.length) {
            let lots = await getTbankrotLotsInfo(feature.get('ids'))
            store.lots = lots;
            if (lots.length === 1) {
                store.info = lots[0];
            }
        }
    }
}

async function getTbankrotLotsInfo(lots) {
    Alpine.store("Karta").loaderLots = true;
    const results = await Promise.all(
        lots.map(async (lot) => {
            let res = await httpGet('/api/karta/tbankrot/' + lot);
            return res?.lot?.id ? res.lot : null;
        })
    );

    Alpine.store("Karta").loaderLots = false;

    return results.filter(Boolean);
}

async function setAnalyticsLayers(changeZoom) {
    let extent = myMap.getView().calculateExtent(myMap.getSize());

    [extent[0], extent[1]] = proj.transform([extent[0], extent[1]], 'EPSG:3857', 'EPSG:4326');
    [extent[2], extent[3]] =  proj.transform([extent[2], extent[3]], 'EPSG:3857', 'EPSG:4326');

    sourceAnalyticsTb.clear();

    let res = await httpRequest('/api/layers/tbankrot', {
        bbox: extent,
        zoom: Math.round(myMap.getView().getZoom()),
        filter: {status: ['active']},
    });
    if (changeZoom) {
        sourceAnalyticsTb.clear();
    }
    if (res?.tbankrot) {
        res.tbankrot.map((lot => {
            let point = new geom.Point(proj.fromLonLat([lot.lon, lot.lat]))
            let feature = new ol.Feature(point);
            feature.set('type', 'trade');
            feature.set('count', lot.count);

            if (lot.lot_ids) {
                feature.set('ids', JSON.parse(lot.lot_ids));
            }

            if (lot.closed) {
                feature.set('closed', JSON.parse(lot.closed));
            }

            sourceAnalyticsTb.addFeature(feature)
        }));
    }

    myMap.on('pointermove', function (event) {
        const hit = myMap.hasFeatureAtPixel(event.pixel);
        if (hit) {
            myMap.getTargetElement().style.cursor = 'pointer'; // меняем курсор на pointer
        } else {
            myMap.getTargetElement().style.cursor = ''; // сбрасываем курсор
        }
    });
}


function Karta() {
    return {
        isFullscreen: false,
        scrollPosition: null,

        zoom(event) {
            if (event === '+') {
                myMap.getView().setZoom(myMap.getView().getZoom() + 1)
            } else {
                myMap.getView().setZoom(myMap.getView().getZoom() - 1)
            }

        },
        async setUserPosition() {
            let coords = await new Promise((resolve) => {
                if (!navigator.geolocation) {
                    resolve(false);
                    return;
                }

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve(proj.fromLonLat([position.coords.longitude, position.coords.latitude]));
                    },
                    (error) => {
                        resolve(false);
                    },
                    {
                        enableHighAccuracy: true, // Использовать GPS для большей точности
                        timeout: 10000,           // Максимальное время ожидания (мс)
                    }
                );
            });

            if (coords) {
                myMap.getView().setCenter([coords[0], coords[1]])
                myMap.getView().setZoom(15);
            }
        },
        toggleFullscreen() {
            const el = document.getElementById('full-map');

            // Инициализация переменной scrollPosition, если вдруг нет
            if (this.scrollPosition === undefined || this.scrollPosition === null) {
                this.scrollPosition = 0;
            }

            // Подписываемся на fullscreenchange только один раз
            if (!this._fullscreenListenerAdded) {
                document.addEventListener('fullscreenchange', () => {
                    const isNowFullscreen = !!document.fullscreenElement;
                    this.isFullscreen = isNowFullscreen;

                    if (!isNowFullscreen && this.scrollPosition !== undefined) {
                        window.scrollTo({ top: this.scrollPosition, behavior: 'auto' });
                    }
                });
                this._fullscreenListenerAdded = true;
            }

            // Тогглим fullscreen
            if (!document.fullscreenElement) {
                this.scrollPosition = window.scrollY;
                el.requestFullscreen().catch(err => {
                    console.error(`Ошибка при входе в fullscreen: ${err.message}`);
                });
            } else {
                document.exitFullscreen().catch(err => {
                    console.error(`Ошибка при выходе из fullscreen: ${err.message}`);
                });
            }
        },
        scrollY: 0,
        info: {},
        loaderLots: false,
        lotInfoShown: true,
        lots: []
    }
}

function getParamsUri() {
    const params = {};
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    urlParams.forEach((value, key) => {
        if (params[key]) {
            if (Array.isArray(params[key])) {
                params[key].push(value);
            } else {
                params[key] = [params[key], value];
            }
        } else {
            params[key] = value;
        }
    });

    return params;
}


